

import { ConfigService } from '../../core/services/config.service';
import { Injectable } from '@angular/core';
import { UpdateIntendedUsage } from '../../core/model/intended-usage';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class IntendedUsageService {
    private configData: any;
    private apiUrl: string;
    private RESOURCE_URL = '/locomotives/';


    constructor(private configService: ConfigService, private http: HttpClient) {
        this.configData = this.configService.getConfigData();
        this.apiUrl = this.configData.urls.API_URL;
    }


    updateIntendedUsage(updateIntUsage: UpdateIntendedUsage) {
        if (updateIntUsage) {
            if (updateIntUsage.intendedUsageCode) {
                updateIntUsage.intendedUsageCode = updateIntUsage.intendedUsageCode.trim().toUpperCase();
            }
            if (updateIntUsage.intendedUsageReason) {
                updateIntUsage.intendedUsageReason = updateIntUsage.intendedUsageReason.trim().toUpperCase();
            }
            if (updateIntUsage.intendedUsageNote) {
                updateIntUsage.intendedUsageNote = updateIntUsage.intendedUsageNote.trim().toUpperCase();
            }
        }
        const apiUrl = this.configData.urls.API_URL;
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        return this.http.post(`${apiUrl}${this.RESOURCE_URL}updateintusage?opr=UINU`, JSON.stringify(updateIntUsage), options);
    }
}
